//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridFormOption from '~/components/product/_GridFormOption.vue';
import Option from './_Option';
import {AppMixin} from '~/node_modules/sitis-nuxt/lib/mixins/index';

export default {

  data: function () {
    return {
      selected: {},

      windowWidth: null,
    };
  },

  mixins: [
    AppMixin
  ],

  props: {

    isScrolled: {
      type: Boolean,
      default: false,
    },

    variants: {
      type: Array,
      default: () => {
        return [];
      }
    },

    productId: {
      type: Number,
      default: 0
    },

    initSelected: {
      type: Object,
      default: () => {
        return {};
      }
    },

    isInitSelected: {
      type: Boolean,
      default: false
    },

    idAutocompleteModifications: {
      type: Boolean,
      default: false
    },
    // для управления отрисовкой надписей глаз
    selectedVariants: {
      type: Array,
      default: () => {
        return []
      }
    },
    parentVariantIndex: {
      type: Number | String,
      default: null
    },

    refOptions: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  components: {
    Option,
    GridFormOption,
  },

  watch: {
    isInitSelected: function () {
      if (!this.isInitSelected) {
        return
      }

      this.selected = this.initSelected;
      this.$emit('change', this.initSelected);
    }
  },

  mounted: async function () {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleWindowSize, true);

    // Устоновка активных значение (при изменении модификаций товара)
    if (this.isInitSelected) {
      this.selected = this.initSelected;
      this.$emit('change', this.initSelected);

      return
    }

    // Устоновка активных значение (устоновка первой доступной модификации)
    if (this.idAutocompleteModifications && false) {
      await this.setAutocompleteModification();
    }
  },
  unmounted: function () {
    document.removeEventListener('resize', this.handleWindowSize);
  },

  methods: {
    isShowGridFormOption: function (name) {
      return ['Оптическая сила (Сфера)', 'Радиус кривизны'].includes(name)
    },

    onChangeVariant: function (groupId, variant, indexGroup) {
      let newSelected = {...this.selected};
      newSelected[groupId] = variant;

      let groupIndex = this.variants.findIndex((t) => +(t.group_id || t.groupId) === +groupId);
      let isDeleteNext = false;
      Object.keys(newSelected)
        .sort((a, b) => {
          const selectedGroupIndexA = this.variants.findIndex((t) => +(t.group_id || t.groupId) === +a);
          const selectedGroupIndexB = this.variants.findIndex((t) => +(t.group_id || t.groupId) === +b);

          if (selectedGroupIndexA < selectedGroupIndexB) {
            return -1
          }
          if (selectedGroupIndexA > selectedGroupIndexB) {
            return 1
          }

          return 0;
        })
        .map((key, index) => {
          if (isDeleteNext) {
            delete newSelected[key];
          }

          if (+index === +indexGroup) {
            isDeleteNext = true;
          }
        });

      this.selected = newSelected;
      this.$emit('change', newSelected);
    },

    getNamePrevGroup: function (groupId) {
      const group = this.variants[groupId];

      return group?.name || '';
    },

    getAvailableOption: function (groupIdxPrev) {
      // 0 элемент
      if (groupIdxPrev === -1) {
        return true;
      }

      const group = this.variants[groupIdxPrev];
      return Boolean(this.selected[this.getGroupId(group)]);
    },

    getGroupId: function (group) {
      return group?.groupId || group?.group_id || 0;
    },

    setAutocompleteModification: async function () {

      // Инициализация активного города пользователя
      const storeCityId = this?.appCfg?.city?.data?.id || null;


      // Получение модификаций товара (которые есть в наличии)
      let modifications = [];

      let search = `products/${this.productId}/modifications?filter[quantity][gt]=0`;
      if (!!storeCityId) {
        search = `${search}&filter[store_city_id]=${storeCityId}&filter[store_quantity][gte]=0`;
      }

      modifications = await this.$api.agent.transport.get(search).then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      if (modifications.length <= 0 && !!storeCityId) {
        modifications = await this.$api.agent.transport.get(`products/${this.productId}/modifications?filter[quantity][gt]=0`).then((res) => {
          return res.data
        }).catch(() => {
          return []
        });
      }
      // -------------------------------------------------------

      const modification = modifications?.[0] || {};

      if (Object.keys(modification).length <= 0) {
        console.warn("Не найдно модификаций товара")

        this.$emit('emptyModification');

        return null
      }

      let newSelected = {};

      modification?.variants.map((variant) => {
        newSelected[variant.group_id] = variant
      });

      this.selected = newSelected;
      this.$emit('change', newSelected);
    },

    handleWindowSize() {
      this.windowWidth = window.innerWidth;
    },

  },
  computed: {
    isMobile() {
      return this.windowWidth < 991;
    },
  }

};
